<script>
  import { Router } from 'svelte-router-spa';
  import { routes } from './routes';

  const options = { defaultLanguage: 'tr' };
</script>

<Router {routes} {options} />
